import { render } from "./uniqueResponse.vue?vue&type=template&id=3b86444d"
import script from "./uniqueResponse.vue?vue&type=script&lang=js"
export * from "./uniqueResponse.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__